var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Image(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 45,
    viewBox: "0 0 95 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_133260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2398 -0.000111009C23.7194 -0.0001049 4.65234 19.0669 4.65234 42.5873V75.8283C4.65234 80.6736 8.58023 84.6014 13.4255 84.6014C19.0174 84.6014 24.6093 84.6014 30.2011 84.6014H64.2784C69.8703 84.6014 75.4622 84.6014 81.054 84.6014C85.8993 84.6014 89.8272 80.6736 89.8272 75.8283V42.5873C89.8272 19.0669 70.7601 -0.000117118 47.2398 -0.000111009Z",
    fill: "#FE00FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.828,
    cy: 41.9468,
    rx: 6.8534,
    ry: 6.85404,
    fill: "#1F1F23"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0816,
    cy: 39.2061,
    rx: 1.37068,
    ry: 1.37081,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.9159,
    cy: 41.9468,
    rx: 6.8534,
    ry: 6.85404,
    fill: "#1F1F23"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.1695,
    cy: 39.2061,
    rx: 1.37068,
    ry: 1.37081,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_133260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.4657,
    height: 45,
    fill: "white",
    transform: "translate(0.267578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404Image.393013bd258f75e92f56985e6ca844ff.svg";
export { ForwardRef as ReactComponent };